'use client'

import { FC } from 'react'
import { UseFormReturn } from 'react-hook-form'
import BaseAuthForm from './BaseAuthForm'
import { AuthResult } from '@/types'
import { SignInFormData } from '@/lib/validations/auth'

type Props = {
  form: UseFormReturn<SignInFormData>
  onEmailSubmit: (data: SignInFormData) => Promise<AuthResult | null>
  onGoogleAuth: () => Promise<{ success: boolean; error?: string }>
  onSwitchMode: () => void
}

const SignInForm: FC<Props> = ({ form, onEmailSubmit, onGoogleAuth, onSwitchMode }) => {
  return (
    <BaseAuthForm
      form={form}
      onEmailSubmit={onEmailSubmit}
      onGoogleAuth={onGoogleAuth}
      authMode="signin"
      onSwitchMode={onSwitchMode}
    />
  )
}

export default SignInForm
